export default __webpack_public_path__ + "images/YU.f24c32d.png";